import baseSel from "./baseSel.js";

export default baseSel('.');